import dryFoodIcon from "../assets/kind-icons/dry-food.svg";
import wetFoodIcon from "../assets/kind-icons/wet-food.svg";
import treatsIcon from "../assets/kind-icons/treats.svg";
import hygieneIcon from "../assets/kind-icons/hygiene.svg";
import medicineIcon from "../assets/kind-icons/medicine.svg";
import carrierIcon from "../assets/kind-icons/carrier.svg";
import accessoriesIcon from "../assets/kind-icons/accessories.svg";
import toysIcon from "../assets/kind-icons/toys.svg";
import milkReplacerIcon from "../assets/kind-icons/milk-replacer.svg";
import vitaminsIcon from "../assets/kind-icons/vitamins.svg";
import litterIcon from "../assets/kind-icons/litter.svg";
import scratcherIcon from "../assets/kind-icons/scratcher.svg";
import cageIcon from "../assets/kind-icons/cage.svg";
import beddingIcon from "../assets/kind-icons/bedding.svg";
import houseBedIcon from "../assets/kind-icons/house-bed.svg";
import bowlsFeedersIcon from "../assets/kind-icons/bowls-feeders.svg";
import aquariumIcon from "../assets/kind-icons/aquarium.svg";
import waterCareIcon from "../assets/kind-icons/water-care.svg";
import terrariumIcon from "../assets/kind-icons/terrarium.svg";
import lightingIcon from "../assets/kind-icons/lighting.svg";
import clothesIcon from "../assets/kind-icons/clothes.svg";
import otherKindIcon from "../assets/kind-icons/other.svg";

const OTHER_KIND_PRESENTATION = {
  priority: 8,
  order: 0,
  image: otherKindIcon,
  alt: "Інші товари",
};

const normalizeKindLabel = (kind) =>
  String(kind || "")
    .toLowerCase()
    .replace(/[’'`ʼ]/g, "")
    .replace(/ё/g, "е");

const hasAnyTerm = (value, terms) => terms.some((term) => value.includes(term));

const hasAllTerms = (value, terms) =>
  terms.every((term) => value.includes(term));

const KIND_PRESENTATIONS = [
  {
    priority: 1,
    order: 0,
    image: dryFoodIcon,
    alt: "Сухий корм",
    matches: (value) => hasAllTerms(value, ["сух", "корм"]),
  },
  {
    priority: 1,
    order: 1,
    image: wetFoodIcon,
    alt: "Вологий корм",
    matches: (value) =>
      hasAllTerms(value, ["волог", "корм"]) ||
      hasAnyTerm(value, ["пауч", "консерв"]),
  },
  {
    priority: 1,
    order: 2,
    image: milkReplacerIcon,
    alt: "Замінник молока",
    matches: (value) =>
      hasAnyTerm(value, ["замінник", "заменител", "молок", "milk"]),
  },
  {
    priority: 1,
    order: 3,
    image: dryFoodIcon,
    alt: "Корм та харчування",
    matches: (value) => hasAnyTerm(value, ["корм", "корма", "харч", "їжа"]),
  },
  {
    priority: 2,
    order: 0,
    image: treatsIcon,
    alt: "Ласощі",
    matches: (value) => hasAnyTerm(value, ["ласощ", "смакол", "лаком"]),
  },
  {
    priority: 3,
    order: 0,
    image: litterIcon,
    alt: "Наповнювач та туалет",
    matches: (value) =>
      hasAnyTerm(value, [
        "наповнювач",
        "наполнитель",
        "туалет",
        "лоток",
        "пісок",
        "песок",
        "пелюш",
      ]),
  },
  {
    priority: 3,
    order: 1,
    image: hygieneIcon,
    alt: "Гігієна та догляд",
    matches: (value) =>
      hasAnyTerm(value, [
        "гігієн",
        "гигиен",
        "догляд",
        "грумін",
        "грумин",
        "шампун",
        "греб",
        "туалет",
        "наповнювач",
        "пелюш",
        "лоток",
      ]),
  },
  {
    priority: 4,
    order: 0,
    image: vitaminsIcon,
    alt: "Вітаміни та добавки",
    matches: (value) =>
      hasAnyTerm(value, [
        "вітам",
        "витам",
        "добав",
        "суплемент",
        "дієтич",
        "диет",
      ]),
  },
  {
    priority: 4,
    order: 1,
    image: medicineIcon,
    alt: "Ветеринарні препарати",
    matches: (value) =>
      hasAnyTerm(value, [
        "вет",
        "препарат",
        "ліки",
        "лiки",
        "лекар",
        "аптеч",
      ]),
  },
  {
    priority: 5,
    order: 0,
    image: carrierIcon,
    alt: "Переноски",
    matches: (value) => hasAnyTerm(value, ["переноск", "carrier", "транспортув"]),
  },
  {
    priority: 6,
    order: 0,
    image: accessoriesIcon,
    alt: "Аксесуари",
    matches: (value) =>
      hasAnyTerm(value, [
        "аксес",
        "амуніц",
        "амуниц",
        "наший",
        "оший",
        "повід",
        "повод",
        "шле",
      ]),
  },
  {
    priority: 7,
    order: 0,
    image: toysIcon,
    alt: "Іграшки",
    matches: (value) => hasAnyTerm(value, ["іграш", "игруш", "мяч", "канат"]),
  },
  {
    priority: 8,
    order: 1,
    image: scratcherIcon,
    alt: "Кігтеточка",
    matches: (value) =>
      hasAnyTerm(value, ["кігтет", "когтет", "дряп", "царап"]),
  },
  {
    priority: 8,
    order: 2,
    image: cageIcon,
    alt: "Клітка",
    matches: (value) => hasAnyTerm(value, ["клітк", "клетк", "вольєр", "вольер"]),
  },
  {
    priority: 8,
    order: 3,
    image: beddingIcon,
    alt: "Підстилка та сіно",
    matches: (value) =>
      hasAnyTerm(value, [
        "підстил",
        "подстил",
        "сіно",
        "сено",
        "солом",
        "тирс",
        "опил",
      ]),
  },
  {
    priority: 8,
    order: 4,
    image: houseBedIcon,
    alt: "Будиночок або лежак",
    matches: (value) =>
      hasAnyTerm(value, [
        "будиноч",
        "домик",
        "лежак",
        "лежан",
        "ліжк",
        "кровать",
        "місце",
      ]),
  },
  {
    priority: 8,
    order: 5,
    image: bowlsFeedersIcon,
    alt: "Миски, годівниці та поїлки",
    matches: (value) =>
      hasAnyTerm(value, [
        "миска",
        "миски",
        "годів",
        "кормуш",
        "поїл",
        "поил",
        "фонтан",
      ]),
  },
  {
    priority: 8,
    order: 6,
    image: aquariumIcon,
    alt: "Акваріум",
    matches: (value) => hasAnyTerm(value, ["акварі", "аквари", "фільтр", "фильтр"]),
  },
  {
    priority: 8,
    order: 7,
    image: waterCareIcon,
    alt: "Догляд за водою",
    matches: (value) =>
      hasAnyTerm(value, [
        "вода",
        "водою",
        "кондиціонер",
        "кондиционер",
        "очищ",
        "тест",
      ]),
  },
  {
    priority: 8,
    order: 8,
    image: terrariumIcon,
    alt: "Тераріум",
    matches: (value) => hasAnyTerm(value, ["терарі", "террари", "рептил"]),
  },
  {
    priority: 8,
    order: 9,
    image: lightingIcon,
    alt: "Освітлення",
    matches: (value) =>
      hasAnyTerm(value, ["освіт", "освещ", "ламп", "uv", "ультрафіолет"]),
  },
  {
    priority: 8,
    order: 10,
    image: clothesIcon,
    alt: "Одяг",
    matches: (value) =>
      hasAnyTerm(value, ["одяг", "одеж", "куртк", "светр", "попон", "комбінез"]),
  },
];

export const getKindPresentation = (kind) => {
  const normalizedKind = normalizeKindLabel(kind);

  return (
    KIND_PRESENTATIONS.find(({ matches }) => matches(normalizedKind)) ||
    OTHER_KIND_PRESENTATION
  );
};

export const compareKindLabels = (a, b) => {
  const first = getKindPresentation(a);
  const second = getKindPresentation(b);

  if (first.priority !== second.priority) {
    return first.priority - second.priority;
  }

  if (first.order !== second.order) {
    return first.order - second.order;
  }

  return String(a).localeCompare(String(b), "uk");
};
